import ApiService from './ApiService'

export const getApiData = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.is_active = data.selectedTab === 'active' ? true : false
        }
    }
    return ApiService.get('/company/company-users/', datas)
}
export const createApiRecord = (data) =>
    ApiService.post('/company/company-users/', data)
export const getApiRecord = (id) =>
    ApiService.get(`/company/company-users/${id}`)
export const updateApiRecord = (id, data) =>
    ApiService.patch(`/company/company-users/${id}/`, data)
export const updateApiStatus = (id, data) =>
    ApiService.patch(`/company/company-users/${id}/`, data)
export const deleteApiRecord = (id) =>
    ApiService.delete('/company/company-users', id)
